import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as l, useRef as m, useState as x, useEffect as d } from "react";
import { Avatar as f } from "../../Avatars/Avatar.js";
import { FeaturedIcon as p } from "../../FeaturedIcon/FeaturedIcon.js";
import { Typography as i } from "../../Typography/Typography.js";
import v from "../components/ActivityItemHeader.js";
import j from "../components/Comment.js";
import u from "../components/Actions.js";
import h from "../../Divider/Divider.js";
import { clsx as g } from "../../../../node_modules/clsx/dist/clsx.m.js";
const y = ({ item: r, timePosition: o, isLastItem: a }) => {
  var s;
  const e = m(null), [n, c] = x(53);
  return d(() => {
    e.current && c(e.current.offsetWidth);
  }, []), /* @__PURE__ */ t.jsxs(
    "div",
    {
      role: "activity_item",
      className: "min-h-[56px] flex gap-100",
      children: [
        /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center", children: [
          "avatarProps" in r ? /* @__PURE__ */ t.jsx(
            f,
            {
              ...r.avatarProps,
              size: "m",
              onClick: void 0,
              className: "cursor-default"
            }
          ) : "iconProps" in r && /* @__PURE__ */ t.jsx(
            p,
            {
              size: "sm",
              ...r.iconProps
            }
          ),
          !a && /* @__PURE__ */ t.jsx(h, { direction: "vertical" })
        ] }),
        /* @__PURE__ */ t.jsxs(
          "div",
          {
            className: g("w-full flex gap-100", {
              "flex-row-reverse": o === "end"
            }),
            children: [
              /* @__PURE__ */ t.jsx("div", { ref: e, children: /* @__PURE__ */ t.jsx(
                i,
                {
                  text: r.time,
                  textColor: "color/fg/lighter",
                  variant: "subtitle-2",
                  className: "py-125 min-w-[53px] max-w-[62px]"
                }
              ) }),
              /* @__PURE__ */ t.jsxs("div", { className: "flex-1", children: [
                /* @__PURE__ */ t.jsx(v, { item: r }),
                "comment" in r && ((s = r.comment) == null ? void 0 : s.text) && r.variant === "inline" && /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
                  j,
                  {
                    comment: r.comment,
                    isLong: o === "start",
                    timeWidth: n
                  }
                ) }),
                r.variant === "extended" && /* @__PURE__ */ t.jsx(
                  i,
                  {
                    text: r.description,
                    variant: "body-new/regular",
                    textColor: "color/fg/lighter"
                  }
                ),
                /* @__PURE__ */ t.jsx(u, { footer: r == null ? void 0 : r.footer })
              ] })
            ]
          }
        )
      ]
    }
  );
}, D = l(y);
export {
  D as default
};
//# sourceMappingURL=ActivityItem.js.map
